import {EventEmitter, Injectable, Output, TemplateRef} from '@angular/core';
import {Subject} from "rxjs";
import {DialogData, DialogDataError} from "./DialogData";
import * as _ from "lodash";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackComponent} from "../snack/snack.component";
import {DialogConfirmComponent} from "./dialog-confirm/dialog-confirm.component";
import {DialogConfirmAltComponent} from "./dialog-confirm-alt/dialog-confirm-alt.component";
import {
   PopupButtonItem,
   PopupGenericComponent,
   PopupSchedaColor, PopupTextColor
} from "../../dialogs/popup-generic/popup-generic.component";
import {DialogErrorComponent} from "./dialog-error/dialog-error.component";
import {AppComponent} from "../../../app.component";

@Injectable({
   providedIn: 'root'
})
export class DialogService {

   dialogSubject = new Subject();

   @Output() okClick = new EventEmitter();
   @Output() cancelClick = new EventEmitter();
   @Output() okAltClick = new EventEmitter();

   private $subscribedOk: any = null;
   private $subscribedCancel: any = null;
   private $subscribedOkAlt: any = null;

   private $innerOk: any = null;
   private $confirm: any = null;

   constructor(public matDialog: MatDialog,
               private matSnackBar: MatSnackBar,
   ) { }

   private flatten(input:any, reference:any=null, output:any=null) {
      output = output || {};
      for (let key in input) {
         var value = input[key];
         key = reference ? reference + '.' + key : key;
         if (typeof value === 'object' && value !== null) {
            this.flatten(value, key, output);
         } else {
            key = key.replace(".0", "");
            output[key] = value;
         }
      }
      return output;
   }

   public getError(err:any, title:any): {title:string, html:string}{

      title = title || "Errore"

      if(!err) return {title:title, html: title}
      // if(!err) return {title:title, html: err}

      if(_.isString(err)) return {title:title, html: err}

      if(err.error && err.error.data && err.error.data.message && !err.error.data.errors) {
         return {title:title, html: err.error.data.message}
      }

      if(err.error && err.error.data && !err.error.data.errors) {
         return {title: title, html: err.error.data}
      }

      if(err.error && err.error.data && err.error.data.errors) {
         let errors = err.error.data.errors;
         errors = this.flatten(errors, null, null);
         var arr_errors:any = [];
         _.each(errors, function (value:any, key:any) {
            arr_errors.push(key + ": " + value)
         });
         errors = arr_errors.join("<br>");
         return {title: title, html:errors}
      }

      if(err.data && err.data.message){
         return {title:title, html: err.data.message}
      }

      if(err.error && err.error.data && err.error.data.message){
         return {title: err.error.data.exc_type, html: err.error.data.message}
      }

      if(err.message && _.isString(err.message)){
         return {title: title, html: err.message}
      }

      if(err.error && err.error.data && err.error.data.message){
         return {title: title, html:err.error.data.message }
      }

      return {title: title, html: "Errore generico"}

   }

   initSubscription(componentRef: any){
      if (this.$subscribedOk) this.$subscribedOk.unsubscribe();
      if (this.$subscribedCancel) this.$subscribedCancel.unsubscribe();
      if (this.$subscribedOkAlt) this.$subscribedOkAlt.unsubscribe();

      if(componentRef.instance.okClick)
         this.$subscribedOk = componentRef.instance.okClick.subscribe(() => this.okClick.emit());
      if(componentRef.instance.cancelClick)
         this.$subscribedCancel = componentRef.instance.cancelClick.subscribe(() => this.cancelClick.emit());
      if(componentRef.instance.okAltClick)
         this.$subscribedOkAlt = componentRef.instance.okAltClick.subscribe(() => this.okAltClick.emit());
   }

   // show(data: DialogData){
   //    return new Promise((resolve, reject) => {
   //       data["type"] = "simple";
   //       this.dialogSubject.next(data);
   //       if (this.$innerOk) this.$innerOk.unsubscribe();
   //       this.$innerOk = this.okClick.subscribe(() => resolve(null));
   //    })
   // }

   showSuccess(data: DialogData){

      try {
         // new Audio('assets/sounds/success.ogg').play();
      }catch (e){}

      let title = data.title ? data.title : "Operazione completata"

      const dialogRef = this.matDialog.open(DialogErrorComponent, {
         panelClass: 'custom-dialog-container',
         disableClose: true,
         data: {
            title: title,
            html: data.msg
         },
         hasBackdrop: true,
         backdropClass:'backdrop-dialog'
      });

      return new Promise((resolve, reject) => {
         this.$confirm = dialogRef.afterClosed().subscribe((result) => {
            if (result) resolve(true)
            else reject(null)
         });
      })
   }

   showError(data: DialogDataError){

      try{
         // new Audio('assets/sounds/error.ogg').play();
      }catch (e){}


      if(!data.err && data.msg){
         data.err = data.msg
      }

      let errObj = this.getError(data.err, data.title)

      const dialogRef = this.matDialog.open(DialogErrorComponent, {
         panelClass: 'custom-dialog-container',
         disableClose: true,
         data: {
            title: errObj.title,
            html: errObj.html
         },
         hasBackdrop: true,
         backdropClass:'backdrop-dialog'
      });

      return new Promise((resolve, reject) => {
         this.$confirm = dialogRef.afterClosed().subscribe((result) => {
            if (result) resolve(true)
            else reject(null)
         });
      })

   }

   showConfirm(data: DialogData):Promise<any>{
      const dialogRef = this.matDialog.open(DialogConfirmComponent, {
         panelClass: 'custom-dialog-container',
         disableClose: true,
         data: data,
         hasBackdrop: true,
         backdropClass:'backdrop-dialog'
      });

      return new Promise((resolve, reject) => {
         this.$confirm = dialogRef.afterClosed().subscribe((result) => {
            if (result)
               resolve(true)
            else
               reject(null)
         });
      })
   }

   showConfirmAlt(data: DialogData){
      const dialogRef = this.matDialog.open(DialogConfirmAltComponent, {
         panelClass: 'custom-alt-dialog-container',
         disableClose: true,
         data: data,
         hasBackdrop: true,
         backdropClass:'backdrop-dialog'
      });

      return new Promise((resolve, reject) => {
         this.$confirm = dialogRef.afterClosed().subscribe((result) => {
            if (result == true)
               resolve(true)
            else if (result == false)
               resolve(false)
            else
               reject(null)
         });
      })
   }

   open(Component, data={}, panelClass:string = ''):any{

      const dialogRef = this.matDialog.open(Component, {
         panelClass:panelClass,
         disableClose: true,
         data: data,

      });
      return new Promise((resolve, reject) => {
         this.$confirm = dialogRef.afterClosed().subscribe((result) => {
            if (result) resolve(true)
            else reject(null)
         });
      })
      // return dialogRef;
   }

   closeAll(){
      this.matDialog.closeAll()
   }

   showToastSuccess(data: DialogData) {
      Object.assign(data, {icon: 'check', typeDialog:'success'})
      // new Audio('assets/sounds/success.ogg').play();
      this.matSnackBar.openFromComponent(SnackComponent, {
         data: data,
         duration:data.duration || 3000,
         panelClass:"success",
         horizontalPosition: "end",
         verticalPosition:"top"
      });
   }

   showToastError(data: DialogData) {
      // {title:message, msg: err}
      let errObj = this.getError(data.err, data.title)

      console.log(errObj)

      Object.assign(data, {typeDialog:'error'}, errObj)
      // new Audio('assets/sounds/err.mp3').play();
      this.matSnackBar.openFromComponent(SnackComponent, {
         data: data,
         duration:data.duration || 3000,
         panelClass:"error",
         horizontalPosition: "end",
         verticalPosition:"top",
      });
   }

   openCustomModal( options:{
                       mode:"normal"|"rb",
                       title?:string,
                       subtitle?:string,
                       scheda_color?:PopupSchedaColor,
                       textColor?:PopupTextColor,
                       autoclose?: boolean,
                       no_animation?: boolean,
                       height?: string,
                       width?: string,
                       content: TemplateRef<any> | null,
                       onClick?: ({button: PopupButtonItem, component: PopupGenericComponent})=> any,
                       buttons: ( null | PopupButtonItem )[],
                    } = {
                       mode:"normal",
                       content: null,
                       buttons: [null]
                    }
   ): PopupGenericComponent
   {
      const componentRef = AppComponent.vcr.createComponent<PopupGenericComponent>(PopupGenericComponent)
      componentRef.instance.mode = options.mode
      componentRef.instance.content = options.content
      componentRef.instance.buttons = options.buttons || []
      componentRef.instance.title = options.title || ""
      componentRef.instance.subtitle = options.subtitle || ""
      componentRef.instance.autoclose = options.autoclose == undefined ? true : options.autoclose;
      componentRef.instance.no_animation = options.no_animation || false;
      componentRef.instance.onClick.subscribe(($e)=>{
         if(options.onClick) {
            options.onClick($e)
         }
      })

      if (options.scheda_color) componentRef.instance.schedaColor = options.scheda_color
      if (options.textColor) componentRef.instance.textColor = options.textColor
      if (componentRef.instance.mode == 'normal'){
         if (options.height) componentRef.instance.height = options.height
         if (options.width) componentRef.instance.width = options.width
      }

      // setTimeout(()=>{
      //    componentRef.instance.visible = true
      // },500)

      componentRef.instance.dxPopupVisible = true
      componentRef.instance.visible = true

      return componentRef.instance
   }

}
